<template>
    <div v-if="show" class="lw-cols multiple-rows multiple-rows-tl one-row-tp multiple-rows-sl multiple-rows-sp main">
        <div class="full-width">
            <div class="learnworlds-main-text-normal">
                {{ message }}
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';

    export default {
        name: "PaymentMessagesComponent",

        data() {
            return {
                componentType: "PaymentMessages",
                rendersWithVue: true,
                show: false
            }
        },

        computed: {
            contextWrapper() {
                return this.hasContext("payment-manager")
                    ? this.findNodeState(this.hasContext("payment-manager")[0].id)
                    : null;
            },

            product() {
                if (!this.contextWrapper) {
                    return {
                        id: null,
                        type: null,
                        coupon: null
                    };
                }

                return this.contextWrapper.getProduct;
            },

            message() {
                return ''
            },
        },

        methods: {
            setVisibility(val) {
                this.show = val;
            }
        }
    }
</script>

